import React from 'react';

const Textarea = ({name,value,placeholder,required,rows,onChange}) => {

  return (
    <div className='my-5'>
        <textarea 
            className='p-4 bg-custom-charcoal border border-custom-light-grey rounded-md w-full resize-none'
            name={name || ''} 
            value={value || ''} 
            placeholder={placeholder || ''} 
            required={required ? true : false}
            rows={rows || 5}
            onChange={onChange || null}
        />
    </div>
  );
};

export default Textarea;
